import { render, staticRenderFns } from "./DashboardLifeskillItem.vue?vue&type=template&id=1e061a64&scoped=true&"
import script from "./DashboardLifeskillItem.vue?vue&type=script&lang=js&"
export * from "./DashboardLifeskillItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLifeskillItem.vue?vue&type=style&index=0&id=1e061a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e061a64",
  null
  
)

/* custom blocks */
import block0 from "./DashboardLifeskillItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports